import { Box, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import BackButton from '../../common/BackButton'
import AiWaitingLogo from './AiWaitingLogo'
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store'
import { useNavigate } from 'react-router-dom'
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants'
import { useTranslation } from 'react-i18next'
import { saveDraft, updatePortfolio } from '../../../store/actions/createPortfolio'

const AiGenerationStep: React.FC = () => {
  const nickname = useAppSelector(state => state.authentication.nickname);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      dispatch(updatePortfolio({ field: 'step', value: 2 }));
      dispatch(saveDraft()).then(() => {
        navigate(AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_STEP_ROUTE.replace(":step", '2'), { replace: true });
      });
    }, 5000);
  }, [dispatch, navigate])

  return <Box display={"flex"} flexDirection={"column"} width={"1400px"}>
    <Box display={"flex"}>
      <BackButton />
    </Box>
    <Box display={"flex"} flexGrow={1} flexDirection={"column"} justifyContent={"flex-start"} alignItems={"center"}>
      <AiWaitingLogo />
      <Typography fontSize={"32px"} fontWeight={"500"} lineHeight={"39.01px"} textAlign={"center"}>{t('CreatePortfolioAiWaitingStart')} {nickname ? nickname : ""}{t('CreatePortfolioAiWaitingMiddle')}<br />{t('CreatePortfolioAiWaitingEnd')}</Typography>
    </Box>
  </Box>
}

export default AiGenerationStep